import { BaseTexture } from '@babylonjs/core';

export class MaterialData {

    constructor(
        public readonly metalic: number,
        public readonly roughness: number,
        public readonly baseTexture: BaseTexture,
        public readonly normalTexture: BaseTexture,
    ) { }
}
